import React from 'react'
import SimpleBar from 'simplebar-react'
import Module from './Module'
import 'simplebar/dist/simplebar.min.css'

class Modules extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            order: []
        }
    }

    componentDidUpdate(props) {
        if (this.state.order.length) {
            this.setState({
                order: []
            })
        }
    }

    getOrder(arr, order) {
        if (!order.length) {
            return arr
        } else {
            return arr.sort((a, b) => {
                let indexA = order.indexOf(a.id)
                let indexB = order.indexOf(b.id)

                return indexA - indexB
            })
        }
    }

    onDragStart = (e, id) => {
        e.preventDefault()

        const sections = document.querySelectorAll('section')
        sections.forEach(item => item.classList.add('reorder'))

        this.order = [...this.props.order]

        this.setState({
            id
        })

        this.calculateDragParameters(e, id)
        this.calculateCoordinates(id)
        this.dragModule = document.querySelector(`[data-drag-module='${id}']`)
        this.dragModule.style.background = 'rgba(0, 0, 0, 0.4)'
        // this.dragModule.style.zIndex = '1'

        document.addEventListener('mousemove', this.onDragMove)
        document.addEventListener('mouseup', this.onDragEnd)

        this.onDragMove(e)
    }

    onDragMove = (e) => {
        e.preventDefault()
        e.stopPropagation()

        let top = e.pageY - this.drag.relY - this.drag.top

        if (this.drag.min > top) {
            top = this.drag.min
        }

        if (this.drag.max < top) {
            top = this.drag.max
        }

        this.dragModule.style.transform = `translate3d(0px, ${top}px, 0px)`

        const bottom = top + this.drag.cellHeight

        if (this.drag.elTop && top < this.drag.markerTop) {
            this.swapColumns(this.drag.elTop, false)
        } else if (this.drag.elBottom && bottom > this.drag.markerBottom) {
            this.swapColumns(this.drag.elBottom, true)
        }
    }

    onDragEnd = (e) => {
        e.preventDefault()

        const sections = document.querySelectorAll('section')
        sections.forEach(item => item.classList.remove('reorder'))

        const els = document.querySelectorAll('[data-drag-module]')
        els.forEach(item => item.style.transform = '')

        if (JSON.stringify(this.order) !== JSON.stringify(this.props.order)) {
            this.setState({
                order: [...this.order]
            }, () => this.props.onReorderModules(this.order))
        }

        this.order = null

        document.removeEventListener('mousemove', this.onDragMove)
        document.removeEventListener('mouseup', this.onDragEnd)

        this.dragModule.style.background = ''
    }

    calculateDragParameters(e, draggableId) {
        const container = document.getElementById('modules').getBoundingClientRect()
        const cell = document.querySelector(`[data-drag-module='${draggableId}']`).getBoundingClientRect()
        const min = container.top - cell.top
        const max = container.height - cell.height + min

        this.drag = {
            top: cell.top,
            min: min,
            max: max,
            relY: e.pageY - cell.top,
            cellHeight: cell.height
        }
    }

    swapColumns(targetId, direction) {
        const trgtEls = document.querySelector(`[data-drag-module='${targetId}']`)
        const transform = (this.drag.cellHeight) * (direction ? -1 : 1)

        if (trgtEls.style.transform) {
            trgtEls.style.transform = ''
        } else {
            trgtEls.style.transform = `translate3d(0px, ${transform}px, 0px)`
        }

        const targetIndex = this.order.indexOf(targetId)
        this.order[this.order.indexOf(this.state.id)] = targetId
        this.order[targetIndex] = this.state.id

        this.calculateCoordinates(this.state.id)
    }

    calculateCoordinates(draggableId) {
        if (draggableId) {
            const itemPosition = this.order.indexOf(draggableId)

            /* Calculate Left Marker */
            this.drag.elTop = null
            if (itemPosition) {
                this.drag.elTop = this.order[itemPosition - 1]
                this.drag.markerTop = this.getColumnMarker(this.drag.elTop)
                if (!this.drag.markerTop === null) {
                    this.drag.elTop = null
                }
            }
            /* Calculate Right Marker */
            this.drag.elBottom = null
            if (itemPosition !== this.order.length - 1) {
                this.drag.elBottom = this.order[itemPosition + 1]
                this.drag.markerBottom = this.getColumnMarker(this.drag.elBottom)
                if (this.drag.markerBottom === null) {
                    this.drag.elBottom = null
                }
            }
        }
    }

    getColumnMarker(elId) {
        const el = document.querySelector(`[data-drag-module='${elId}']`)
        if (el) {
            const box = el.getBoundingClientRect()
            return box.top - this.drag.top + (box.height / 2)
        }
        return null
    }

    render() {
        const { currentModule, permissions, mobile } = this.props
        const modules = this.getOrder(this.props.modules, this.state.order)

        return (
            <SimpleBar autoHide={false} style={{ height: '300px' }} id='modules'>
                {modules.map(item =>
                    <Module key={item.id}
                        id={item.id}
                        selected={currentModule && currentModule === item.id}
                        mobile={mobile}
                        icon={item.icon}
                        name={item.name}
                        permissions={permissions}
                        onClick={this.props.handleOpen}
                        onDrag={this.onDragStart}
						search={this.props.search}
						resetFilter={this.props.resetFilter}
                    />
                )}
            </SimpleBar>
        )
    }
}

export default Modules
